export enum PusherEvents {
  SUBSCRIPTION_SUCCESS = 'pusher:subscription_succeeded',
  NEW_USER_ONLINE = 'pusher:member_added',
  NEW_USER_OFFLINE = 'pusher:member_removed',
  MESSAGE_CHATROOM = 'message',
  NEW_MESSAGE = 'new-message',
}
